import * as React from "react"
const Sort = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={props.width}
    height={props.height}
    fill="none"
    {...props}
  >
    <path fill="url(#a34)" d="M0 0h15v15H0z" />
    <defs>
      <pattern
        id="a34"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#b34" transform="scale(.00781)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAA3NCSVQICAjb4U/gAAAALVBMVEVHcEwUFzEQFC0TFDATFjAVFzEVFjEAAyIVFzEUFjAUFjAUFjEUFjEVFzEWGDIT9VuiAAAADnRSTlMAwg8kOtifBfl0V7OMy9OZwV0AAAABYktHRACIBR1IAAADnElEQVR4nO2b2ZLrIAxEs+NMEv7/c2duFlsCAWrJOFW30Ftm4uhYbRXN4t0uixDf8ZP/D4s4xx64Khw/V52/A7C7z5cdvgIQlsu8GtgATstlXg1sAJflsnj8AgBRIMbr9gCBKBCnaXuA3Y1WwKmBBeDA8js1sAD8cIC4OcAjAXBpYABIFIjxvi1ASBWIMWwKsDtnAB4NcIBjlt+lAQ5wzQE8GuAAkwBw2hBAUCDGy4YAkgIeDVCAIOZ3aAACBKrA4sscGqAVIElvdFQ2a4BWgJadfdgIgN80LcdGAMQMXnhLWu05BpAWnXy02nMIIKSP3RW63A9AzeBzAFpBAwiAWpHXEEwGBqMGEAC1Iq+/EA2MUyQIgJjBtxX2a4AA5AqsoAEAQM3gPB0if7NpgFSAmMF5MiJVpRcA1fs2x0I1maZIAIBsRUiYpqkAgGQGeVg00AOIZpCHRQM9QFOBaJqmqgEKZtCtgRYgKBQwTZHUFbiX05LAraG6Aqr8Bg20AKdyUhq4BlqASzkpC1gDJUDVgbvsuQ4gM4M8uFfuAZCZQR6eKZIOoDHoejTQAeRmkIdjiqQDyM0gD6oBaA1VAE3b49BABSCZQR52DXQSdIwBMAAGwAAYAANgAAyAATAAVAD7iATmywfAABgA/yMAtla4PkCP9YH7pRosP7p1pQKoBl/Gh5dK3QD8XBW+i+8F4GvI536r5YVIdhEMm6c+gAPfyGo14HHKCWsAp3PjjgLvz1YD/pUrJ6gA/MnbIMAa8ClXRlAGeD5ejxoBb8DWnt3ncUl+sQjwfrwrNeAN2Fqnnx/XpAYlgLm9ijXAGrB40KAAQH69QIA1IPs2q4EMwO5OPBeQnGxtNSD/NsUVAZItMuEHAz/a2xwBk3qRGkgASX6pAvAImG68zgQCQJpfkBdrwGoNcgBFfqwB6zXIABT5+Vce2hFQrkEKoMhvHgHFGiQAivxgA7ZqwAEU+QM/2Y1ZUKEGDECRH2/ARg0ogOb+DQ1YrwEB0Ny/qQFrBMRSJbMPMT9n3JvO8qoOoxTy82sFg7cegZjf0YAogZjf1YAYgezD2OtNk+stuwaBnJ8fJHK+YVYlkPPzBnS92dMgkPOv0YA6Ajk/N5XWBtQQyPmTBqwfbXQRyPlD/m7TCgASQWEedMu/uQZATlCah2GrZHqAlKA4D+wGwAnK89B+AJSgMg/uCLAQ1NYiegJ8CKprIV0BXgT1tZi+AP8I6vl/AVHg+Ze1YBsHAAAAAElFTkSuQmCC"
        id="b34"
        width={128}
        height={128}
      />
    </defs>
  </svg>
)
export default Sort
